import { GET_SHOPPING_HISTORY, SHOPPING_HISTORY_ERROR } from "./types";
import { firebase } from "../../firebase";
import axios from "axios";

export const getShoppingHistory = (email) => async (dispatch) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/getShoppingHistory`,
      {
        token,
        email,
      }
    );

    data.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });

    dispatch({
      type: GET_SHOPPING_HISTORY,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SHOPPING_HISTORY_ERROR,
      payload: error,
    });
  }
};
